import * as React from "react"
import { List } from "immutable"
import { Link } from "./library/link"
import { Teasers, TeaserProps, SliderTeaser } from "./teaser"
import Slider from "react-slick";

export interface CarouselContentGridItem {
  readonly title: string
  readonly subtitle?: string
  readonly label?: string
  readonly imageAlt?: string
  readonly imageUrl?: string
  readonly imageUrlLarge?: string
  readonly videoUrl?: string
  readonly linkUrl: string
}

export interface CarouselContentGridBlockProps {
  title?: string
  items: List<CarouselContentGridItem>
  primaryActionTitle?: string
  primaryActionUrl?: string
}

export type CarouselContentGridBlockState = {
  mobile: boolean
}

export class CarouselContentGridBlock extends React.Component<CarouselContentGridBlockProps, CarouselContentGridBlockState> {

    constructor(props: CarouselContentGridBlockProps) {
        super(props)
        this.state = { mobile: this.mediaquery.matches }
    }

    mediaquery = window.matchMedia("(max-width: 1024px)")

    handleResize = (e) => this.setState(s => ({...s, mobile: e.matches}))
  
    componentDidMount() {
      this.mediaquery.addListener( this.handleResize )
    }

    componentWillUnmount() {
      this.mediaquery.removeListener( this.handleResize )
    }

    render() {
        const p = this.props
    
        const teaserprops = p.items.map<TeaserProps>((i, k) => ({
          key: `carousel-content-grid-item-${k}`,
          extraClasses: 'block__item col-xs-12 col-sm-6 col-md-4',
          headingLevel: p.title && p.title != "" ? 'h3' : 'h2',
          title: i.title,
          linkUrl: i.linkUrl,
          intro: i.subtitle,
          label: i.label,
          imageUrl: i.imageUrl,
          imageUrlLarge: i.imageUrlLarge,
          imageAlt: i.imageAlt,
          videoUrl: i.videoUrl ? i.videoUrl.replace("youtube.com", "youtube-nocookie.com") : ""
        })).toList()
        
        return (
          <section className="block block--content-grid-carousel container--lg align--center">
            <div className="block__inner">
              {(p.title && p.title != "") && (
                <header className="block__header container--m align--center">
                  <h2 className="block__title title--l container--xs">{p.title}</h2>
                </header>
              )}
  
              {this.state.mobile
                ? <Slider {... {
                    accessibility: true,
                    dots: true,
                    arrows: false,
                    infinite: false,
                    className: "center",
                    centerMode: true,
                    centerPadding: "0",
                    speed: 500,
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    dotsClass: "slick-dots"
                  }}>
                    {teaserprops.map((i) => <SliderTeaser {...i} />)} 
                  </Slider>
                : <Teasers items={teaserprops} />
              }
  
              {(p.primaryActionTitle && p.primaryActionUrl) && (
                <footer className="block__actions container--m align--center">
                  <Link className="button button--primary button--arrow" url={p.primaryActionUrl}>
                    <span className="button__label">{p.primaryActionTitle}</span>
                  </Link>
                </footer>
              )}
            </div>
          </section>
        )
      }
}

{/* TH: Added to styleguide! */}
